import generateUniqueId from "generate-unique-id";
import parseId from "../utils/parseId";
import splitCamelCaseToString from "../utils/splitCamelCaseToString";
import { v4 as uuidv4 } from "uuid";
import { uniqueIdGenertorInNumber } from "../utils/structureFormJSON";
import store from "store";
import { filterSelectedItems } from "../components/RefreshDynamicFormGeographyBtn";

function convertJsonOfDropPin(question: any, data: any) {
  const {
    mapCenterPoint,
    selectedDefaultLayers,
    id,
    ableToCheckMultiple,
    enableSnapping,
    title,
    description,
    isRequired,
    zoomLevel,
    markerGroup,
    markerStyle,
  } = data;

  const parseIdToNumber = (id: any) => Number(parseId(id, "-"));

  const { allGlobalCommunityLayers } = store.getState()?.surveyJS;


  const selectedLayers = filterSelectedItems(
    selectedDefaultLayers.map((layer: any) => ({
      ...layer,
      id: parseIdToNumber(layer.id),
    })),
    allGlobalCommunityLayers
  );

  const structuredData = {
    id,
    name: question.name,
    title: title ?? splitCamelCaseToString(question.name),
    type: question.type,
    description,
    isRequired,
    center_point: [mapCenterPoint.longitude, mapCenterPoint.latitude],
    drop_multiple: ableToCheckMultiple,
    enable_snapping: enableSnapping,
    selected_layers: selectedLayers,
    elementId: uuidv4(),
    questionId: uniqueIdGenertorInNumber(),
    zoomLevel: zoomLevel,
    selected_layers_ids: selectedLayers.map((l: any) => l.id),
    markerGroup,
    markerStyle,
  };

  return structuredData;
}

export { convertJsonOfDropPin };
